<script setup lang="ts">
import type { Contract } from '~/layers/forms/models'

interface Props {
  data: Contract
}

defineProps<Props>()

const { RemoteConfigurationStore } = stores()
const branch = RemoteConfigurationStore.value?.ramoEnum
</script>

<template>
  <FormsPersonResume
    :model="data.customer"
    :address="data.address"
    :contact="data.contact"
  />

  <!--   <FormsPersonResume
    v-if="branch === 'Personas'"
    tag="Información del asegurado"
    :customer="data.insured"
  /> -->

  <FormsVehicleResume
    v-if="branch === 'Auto'"
    :model="data.vehicle"
  />

  <FormsTravelResume
    v-if="branch === 'Viajes'"
    :model="data.travel"
  />

  <FormsPetResume
    v-if="branch === 'Mascotas'"
    :model="data.pet"
  />
</template>
